import { apiClient } from '_app'
import { CancelToken } from 'axios'
import { ApiResponse } from 'dtos'
import { FedExCountryCodeDto, FedExDeliveryTypeDto, FedExPackageTypeDto, FedExUSStateCodeDto } from 'dtos/fedEx'
import { download } from 'utils'

const baseURL = (): string => '/api/fedex'

export const getCountryCodes = (cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<FedExCountryCodeDto[]>>(`${baseURL()}/country-codes`, { cancelToken }).then(res => res.data)

export const getDeliveryTypes = (cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<FedExDeliveryTypeDto[]>>(`${baseURL()}/delivery-types`, { cancelToken }).then(res => res.data)

export const getPackageTypes = (cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<FedExPackageTypeDto[]>>(`${baseURL()}/package-types`, { cancelToken }).then(res => res.data)

export const getUSStateCodes = (cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<FedExUSStateCodeDto[]>>(`${baseURL()}/us-state-codes?countryCode=US`, { cancelToken }).then(res => res.data)

export const getStateProvinceCodes = () => apiClient.get<ApiResponse<FedExUSStateCodeDto[]>>(`${baseURL()}/us-state-codes`).then(res => res.data)

export const generateFedExLabels = (fedExShipmentGuids: string[], cancelToken?: CancelToken) =>
  apiClient
    .post(
      `${baseURL()}/labels`,
      { fedExShipmentGuids },
      {
        cancelToken,
        responseType: 'blob'
      }
    )
    .then(res => {
      download(res.data, getFedExLabelsFileName(), 'application/pdf')
    })

const getFedExLabelsFileName = (): string => {
  const now = new Date()
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Detroit',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
  }).formatToParts(now)

  const value = (type: Intl.DateTimeFormatPartTypes) => parts.find(part => part.type === type)?.value ?? ''
  return `FedExLabels${value('year')}${value('month')}${value('day')}${value('hour')}${value('minute')}${value('second')}${now
    .getMilliseconds()
    .toString()
    .padStart(3, '0')}.pdf`
}
